<template>
    <div class="loading" v-if="visible || loading">
        <div class="loader">
            <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
import { inject, onMounted, ref } from 'vue'

export default {

    props: ['visible'],

    setup() {

        const loading = ref(false)
        const emitter = inject('emitter')

        onMounted( () => {
            emitter.on('data-load-start', () => loading.value = true)
            emitter.on('data-load-end', () => loading.value = false)
        });

        return {
            loading
        }
    }
}
</script>
